import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { normalize } from 'normalizr';

import { consolidation } from '@futrli-sdk/consolidations';
import { permission, workspace, Workspace, WorkspacesListingItem } from '@futrli-sdk/workspaces';

import { API_PATHS, ROUTE_PARAMS } from '../../app-core/constants';
import { interpolatePathParams } from '../../path';
import {
  API_REQUEST,
  getFromNormalisedStoreByPath,
  markAsStale,
  NORMALISATION_FLAGS,
  REQUEST_METHODS,
  updateNormalisedStore
} from '../../redux-helpers';
import {
  CREATE_WORKSPACE,
  GET_ALL_WORKSPACE_CONSOLIDATIONS,
  GET_ALL_WORKSPACES_DATA,
  GET_WORKSPACE_BY_ID,
  GET_WORKSPACE_PERMISSIONS,
  GET_WORKSPACES
} from '../core/constants';

/**
 * This should never really have been added.
 *
 * RIP Flushy, you were too beautiful for this world.
 *
 * @deprecated
 * @param {string} type
 * @returns {DispatchAny}
 */
export const flushy = (type: string) => markAsStale(type);

export const getWorkspaces = () => getFromNormalisedStoreByPath(API_PATHS.WORKSPACES, GET_WORKSPACES, [workspace]);

export const getAllWorkspacesData = (forceFetch = false) =>
  getFromNormalisedStoreByPath(API_PATHS.ALL_WORKSPACES_DATA, GET_ALL_WORKSPACES_DATA, [workspace], forceFetch);

export const getWorkspaceById = (id: string) => {
  const interpolated: string = interpolatePathParams(API_PATHS.WORKSPACE_BY_ID, {
    [ROUTE_PARAMS.WORKSPACE_ID]: id
  });

  return getFromNormalisedStoreByPath(interpolated, GET_WORKSPACE_BY_ID, workspace);
};

export const getWorkspaceConsolidationsById = (id: string, force = false) => {
  const interpolated = interpolatePathParams(API_PATHS.CONSOLIDATIONS, {
    [ROUTE_PARAMS.WORKSPACE_ID]: id
  });

  return getFromNormalisedStoreByPath(interpolated, GET_ALL_WORKSPACE_CONSOLIDATIONS, [consolidation], force);
};

export const getWorkspacePermissionsById = (id: string) => {
  const interpolated = interpolatePathParams(API_PATHS.WORKSPACE_PERMISSIONS, {
    [ROUTE_PARAMS.WORKSPACE_ID]: id
  });

  return getFromNormalisedStoreByPath(interpolated, GET_WORKSPACE_PERMISSIONS, [permission]);
};

export const createWorkspace = (payload: Partial<Workspace>) => ({
  type: CREATE_WORKSPACE.ACTION,
  payload: {
    request: {
      method: REQUEST_METHODS.POST,
      url: API_PATHS.WORKSPACES,
      data: payload,
      headers: {
        'Content-Type': 'application/json'
      }
    }
  },
  meta: {
    schema: workspace,
    flag: API_REQUEST,
    normalisation: NORMALISATION_FLAGS.FLUSH_REQUEST_URL
  }
});

export const updateWorkspaces = async (
  payload: WorkspacesListingItem[] | null,
  dispatch: ThunkDispatch<unknown, unknown, Action>
) => {
  const normalisedWorkspaceData = normalize(payload, [workspace]);
  await updateNormalisedStore(normalisedWorkspaceData, 'Workspace', API_PATHS.ALL_WORKSPACES_DATA)(dispatch);
};
